export default __webpack_public_path__ + "static/media/c.6ce1f76f.png";